import * as api from "../../api/index";
import * as endpoints from "../../api/endpoints";
import * as types from "../../mutation-types";

const actions = {
  getWorks({ commit }, payload) {
    return api.fetch(endpoints.WORKS, payload, commit, (response) => {
      commit(types.SET_WORKS, response.data);
    });
  },
  getWork({ commit }, payload) {
    return api.fetch(endpoints.WORKS + "/" + payload.uuid, payload, commit, (response) => {
      commit(types.SET_WORK, response.data);
    });
  },
  createWork({ commit }, payload) {
    return api.post(endpoints.WORKS, payload, commit);
  },
  updateWork({ commit }, payload) {
    return api.put(endpoints.WORKS + "/" + payload.uuid, payload, commit);
  },
  deleteWork({ commit }, payload) {
    return api.remove(endpoints.WORKS + "/" + payload.uuid, payload, commit);
  },
  getWorkDateIntervalUnitPrices({ commit }, payload) {
    const endpoint = endpoints.WORK_DATE_INTERVAL_UNIT_PRICES.replace("{work_uuid}", payload.work_uuid);
    return api.fetch(endpoint, {}, commit);
  },
  syncWorkDateIntervalUnitPrices({ commit }, payload) {
    const endpoint = endpoints.WORK_DATE_INTERVAL_UNIT_PRICES.replace("{work_uuid}", payload.work_uuid);
    return api.put(endpoint, { items: payload.items }, commit);
  },
  //
  getWorkMainGroups({ commit }, payload) {
    return api.fetch(endpoints.WORK_MAIN_GROUPS, payload, commit);
  },
};

export default actions;
